module.exports = __webpack_public_path__ + "img/agromich-logo-footer.084aaaad.png";